<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #F0F0F0;">
    <div class="row" style="">
      <div class="store-head">
        <div class="back-link" @click="$router.back()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="category-title">
          <div style="margin-top: 16px; font-size: 20px;"> {{ $t('CHALLENGES') }}</div>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="showList"></div>
    <div class="row mt-8" v-else>
      <div class="col-lg-12">
        <div class="d-flex justify-content-center align-items-center vh-100">
          <span class="nothing-found"> {{ $t('NO_CHALLENGE') }}  </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="d-flex justify-content-center fixed-bottom challenge-footer-fix">
        <argon-button fullWidth color="danger"
                      variant="gradient"
                      class="my-4 mb-1 me-2 challenge-btn"
                      @click="selectFriend">
          {{ $t('CHALLENGE_NOW') }}
        </argon-button>
      </div>
    </div>


  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import _ from "lodash";
import ArgonButton from "@/components/ArgonButton";

export default {
  name: "Challenge",
  components: {
    Loader,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      challengeList: [],
      showList: false,
    }
  },
  created() {
    this.getChallengeList();
  },
  methods: {
    getChallengeList() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/challenge/list', {}, this.config)
          .then( response => {
            this.loaderActive = false;
            this.challengeList = response.data.challenges;
            this.showList = ! _.isEmpty(this.challengeList)
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    selectFriend() {
      this.$router.push({path: '/select-friends'})
    }
  }
}
</script>

<style scoped>

</style>
